<template>
  <div>
    <!-- @modified ana.castro 2019.12.20 SCLAPP-23: customer's profile picture-->
    <v-flex v-if="customer.profile_picture && baseUrl"
            align-center
            justify-center
            layout
            text-xs-center
    >
      <v-avatar :size="80">
        <img v-bind:src="baseUrl + customer.profile_picture" alt="avatar">
      </v-avatar>
    </v-flex>
    <v-text-field
        v-model="customer.name"
        :rules="nameRules"
        :counter=false
        v-bind:label="$vuetify.t('$vuetify.profile.name')"
    ></v-text-field>
    <v-menu
        ref="menu"
        :close-on-content-click="false"
        v-model="menu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
    >
      <v-text-field
          slot="activator"
          v-model="customer.birth_date"
          :rules="birthDateRules"
          v-bind:label="$vuetify.t('$vuetify.profile.birth_date')"
          readonly
          clearable
      >
      </v-text-field>

      <v-date-picker
          ref="picker"
          v-model="customer.birth_date"
          :locale="locale"
          :max="new Date().toISOString().substr(0, 10)"
          :min="minBirthDate"
          @change="save"
      >
      </v-date-picker>


    </v-menu>
    <v-text-field v-if="email_definition && email_definition.status === 1"
                  v-model="customer.email_address"
                  :rules="emailRules"
                  label="E-mail"
    ></v-text-field>
    <!-- @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number-->
    <VuePhoneNumberInput v-if="socialLogin"
                         v-model="username"
                         :default-country-code="countryCode"
                         :preferred-countries="preferredCountryCodes"
                         :dark="dark_theme"
                         required
                         :translations="{countrySelectorLabel: this.$vuetify.t('$vuetify.help_country_code'),
                                                                      phoneNumberLabel: this.$vuetify.t('$vuetify.help_mobile_number'),
                                                                      example: this.$vuetify.t('$vuetify.help_example')}"
                         @update="define_selected_country_code"
    />
    <v-text-field v-if="!socialLogin"
                  :disabled="'disabled'"
                  v-model="customer.telephone"
                  :rules="phoneRules"
                  type="tel"
                  :counter=false
                  required
                  v-bind:label="$vuetify.t('$vuetify.phone_number')"
    ></v-text-field>

    <!-- @modified ana.castro 2019.12.06 Tax Number must be displayed on the Profile -->
    <!-- modified @daniel.silva 2020.07.12 Tax Number is always enabled
                  :disabled="!newUser? 'disabled' : undefined"
    -->
    <v-text-field v-if="tax_number_definition && tax_number_definition.status === 1"
                  v-model="customer.tax_number"
                  v-bind:label="$vuetify.t('$vuetify.profile.tax_number')"
                  :rules="taxNumberRules"
    ></v-text-field>

    <v-select v-if="gender_definition && gender_definition.status === 1"
              v-model=customer.gender
              :items="genderOptions()"
              :rules="genderRules"
              v-bind:label="$vuetify.t('$vuetify.profile.gender')"
              item-value="value"
              item-text="text"
              return-object
    ></v-select>

    <!-- @modified ana.castro 2019.11.26 SCLAPP-23: Customer's favourite store-->
    <v-select v-model=customer.favourite_store
              :items="favouriteStoreOptions"
              v-bind:label="$vuetify.t('$vuetify.profile.favourite_store')"
              item-value="value"
              item-text="text"
              return-object
    ></v-select>

    <!--modifed @daniel.silva 2020.06.28 SCLAPP-29 Fatura Sem Papel-->
    <v-checkbox
        v-if="checkbox_text_einvoice"
        v-model="customer.send_7"
        :rules="agreementRules(checkboxs_contact_type.einvoice.mandatory)"
        v-bind:label="checkbox_text_einvoice"
    ></v-checkbox>
    <!-- Section for the RGPD, Policy and Terms and Communication means-->
    <!--This section has three major sentences preceded by checkboxes and
        it may also have a section in between related to the communication channels, also preceded by checkboxes. -->
    <!-- All these sentences and communication channels have attributes defined by the clapp service getprofiledefinitions: -->
    <!--1 - the text
        2 - the label
        3 - whether or not it is mandatory to accept them
        4 - which are the communication channels to display. -->
    <!--    Incompatibility Component between version 1.5.x and 2.0.x
            https://stackoverflow.com/questions/57831539/unknown-custom-element-v-expansion-panels-->
    <!-- @modified ana.castro 2019.12.03 SCLAPP-23: the communication preferences may be grouped in an exclusive section -->
    <v-expansion-panel v-model="panel">
      <v-expansion-panel-content :readonly="attr_readonly" :hide-actions="attr_hide_actions"
                                 style="background:transparent">
        <template v-slot:header>
          <div> {{ $vuetify.t('$vuetify.profile.communication_preferences') }}</div>
        </template>
        <v-checkbox v-if="checkbox_text_tc_accept"
                    v-model="customer.gdpr_agreement"
                    :rules="agreementRules(mandatory=1, context=1)"
                    required
                    @click="tcOpenDialog"
        >
          <!-- @modified ana.castro 2020.05.11 SCLAPP-25 Communication Preferences with HTML formatting-->
          <template v-slot:label>
            <span v-html="checkbox_text_tc_accept"></span></template>
        </v-checkbox>

        <v-checkbox
            v-if="checkbox_text_personal_campaigns && checkboxs_contact_type && checkboxs_contact_type.personalized"
            v-model="customer.send_6"
            :rules="agreementRules(checkboxs_contact_type.personalized.mandatory)"
            v-bind:label="checkbox_text_personal_campaigns"
        ></v-checkbox>

        <v-checkbox v-if="checkbox_text_communications_accept"
                    v-model="customer.send_communication_generally"
                    :rules="agreementRulesGeneric"
                    v-bind:label="checkbox_text_communications_accept"
                    required
                    @click.native="cbGenericSelect"
        ></v-checkbox>
        <!-- The communication channels are displayed only when the user is editing his profile.-->
        <!-- If the user is creating his profile, these options are not displayed. &ndash;&gt;-->
        <v-layout row wrap>
          <v-flex
              v-if="checkbox_text_communications_accept && checkboxs_contact_type && checkboxs_contact_type.email && !newUser"
              xs4 md2>
            <v-checkbox
                v-model="customer.send_1"
                :rules="agreementRules(checkboxs_contact_type.email.mandatory)"
                v-bind:label=checkboxs_contact_type.email.name
                @click.native="cbSpecificSelect"
            ></v-checkbox>

          </v-flex>
          <v-flex
              v-if="checkbox_text_communications_accept && checkboxs_contact_type && checkboxs_contact_type.sms && !newUser"
              xs4 md2>
            <v-checkbox
                v-model="customer.send_2"
                :rules="agreementRules(checkboxs_contact_type.sms.mandatory)"
                v-bind:label=checkboxs_contact_type.sms.name
                @click.native="cbSpecificSelect"
            ></v-checkbox>

          </v-flex>
          <v-flex
              v-if="checkbox_text_communications_accept && checkboxs_contact_type && checkboxs_contact_type.phone && !newUser"
              xs4 md2>
            <v-checkbox
                v-model="customer.send_3"
                :rules="agreementRules(checkboxs_contact_type.phone.mandatory)"
                v-bind:label=checkboxs_contact_type.phone.name
                @click.native="cbSpecificSelect"
            ></v-checkbox>

          </v-flex>
          <v-flex
              v-if="checkbox_text_communications_accept && checkboxs_contact_type && checkboxs_contact_type.notification && !newUser"
              xs6 md2>
            <v-checkbox
                v-model="customer.send_4"
                :rules="agreementRules(checkboxs_contact_type.notification.mandatory)"
                v-bind:label=checkboxs_contact_type.notification.name
                @click.native="cbSpecificSelect"
            ></v-checkbox>

          </v-flex>
          <v-flex
              v-if="checkbox_text_communications_accept && checkboxs_contact_type && checkboxs_contact_type.onlinead && !newUser"
              xs6 md2>
            <v-checkbox
                v-model="customer.send_5"
                :rules="agreementRules(checkboxs_contact_type.onlinead.mandatory)"
                v-bind:label="checkboxs_contact_type.onlinead.name"
                @click.native="cbSpecificSelect"
            ></v-checkbox>

          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
              $vuetify.t('$vuetify.gdpr_agreement.program_terms_policy')
            }}{{ loyalty_program_name }}</span>
        </v-card-title>
        <v-card-text v-html="dialog_text">
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat="flat" @click="disagree">
            {{ $vuetify.t('$vuetify.gdpr_agreement.gdpr_agreement_disagree') }}
          </v-btn>
          <v-btn color="primary" flat="flat" @click="agree">
            {{ $vuetify.t('$vuetify.gdpr_agreement.gdpr_agreement_agree') }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {apiFetch} from '../_helpers';
import {storesService} from '../_services'
import {getDistanceFromLatLonInKm} from '../_helpers'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: "UserForm",
  components: {VuePhoneNumberInput},
  //Parent (User.vue and UserRegister.vue) to Child (UserForm.vue) Communication
  //The "props" are the element which enable moving data from a parent component to a child component
  //"Props" is short for “properties” and is referring to properties set from the parent component
  //Note that props are strictly for one way communication from the parent to the child,
  // and you do not want to try and change the value of a prop directly in the child component.
  // To change a parent's property, a computed property from the parent should be used.
  props: {
    customer: Object,
    newUser: Boolean,
    username: String,
    setLoadedDefinitions: Function,
    socialLogin: Boolean
  },
  data: () => ({
    dark_theme: true,
    panel: [],
    attr_readonly: 'readonly',
    attr_hide_actions: true,
    valid: true,
    menu: false,
    dialog: false,
    checkbox_text_tc_accept: null,
    checkbox_text_communications_accept: null,
    checkbox_text_personal_campaigns: null,
    checkbox_text_einvoice: null,
    checkboxs_contact_type: null,
    dialog_text: null,
    loyalty_program_name: null,
    email_definition: {status: 1},
    tax_number_definition: {status: 1},
    gender_definition: {
      status: 1,
      options: []
    },
    stores: null,
    location: '',
    locale: "pt"
  }),
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
    },
    tcOpenDialog() {
      if (this.customer.gdpr_agreement === 1) {
        this.customer.gdpr_agreement = !this.customer.gdpr_agreement;
        this.dialog = true
      } else {
        this.dialog = true
      }
    },
    cbGenericSelect() {
      if (this.customer.send_communication_generally) {
        this.customer.send_1 = 1;
        this.customer.send_2 = 1;
        this.customer.send_3 = 1;
        this.customer.send_4 = 1;
        this.customer.send_5 = 1;
      }
    },
    cbSpecificSelect() {
      if (!this.customer.send_1 || !this.customer.send_2 || !this.customer.send_3 || !this.customer.send_4 || !this.customer.send_5) {
        this.customer.send_communication_generally = 0;
      } else if (this.customer.send_1 && this.customer.send_2 && this.customer.send_3 && this.customer.send_4 && this.customer.send_5) {
        this.customer.send_communication_generally = 1;
      }
    },
    disagree() {
      this.customer.gdpr_agreement = 0;
      this.dialog = false
    },
    agree() {
      this.customer.gdpr_agreement = 1;
      this.dialog = false
    },
    clearDate() {
      this.birth_date = ''
    },
    calculateAge(str_date) {
      let date = new Date(str_date);
      let diff_ms = Date.now() - date.getTime();
      let age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
    checkMinors(date) {
      //By convention of RGPD minors have less than 13 years
      const minorsAge = 13;

      return this.calculateAge(date) > minorsAge;
    },
    genderOptions() {
      var returnOptions = [];

      if (this.gender_definition.mandatory === 0) {
        returnOptions.push('')
      }
      if (this.gender_definition.options.includes('M')) {
        returnOptions.push({text: this.$vuetify.t('$vuetify.profile.gender_male'), value: 'M'})
      }

      if (this.gender_definition.options.includes('F')) {
        returnOptions.push({text: this.$vuetify.t('$vuetify.profile.gender_female'), value: 'F'})
      }

      if (this.gender_definition.options.includes('O')) {
        returnOptions.push({text: this.$vuetify.t('$vuetify.profile.gender_other'), value: 'O'})
      }

      return returnOptions
    },
    //Typically this validation Rule should be defined on the computed section.
    //However, in this case, this validation Rule has to be a function, since it must access data property.
    // Therefore, it is defined on the methods section
    agreementRules(mandatory, context) {
      /**
       * The T&C only in Registration are mandatory or if the user has never accepted de TC,
       *  in Profile the user can unselect this and leave app
       */

      //Contexto Policy and Terms
      if (context) {
        //Se é um novo registo é OBR a preencher o campo
        if (this.newUser) {
          return [v => !!v || this.$vuetify.t('$vuetify.gdpr_agreement.agreement_mandatory')]
          //Se não é novo registo mas a FLAG de validar profile está ON e o atributo do cliente diz que o profile NÃO está validado
          // então é OBR preencher o campo
        } else if (this.username.mandatory_validate_profile === 1 && this.customer.gdpr_agreement === 0) {
          return [v => !!v || this.$vuetify.t('$vuetify.gdpr_agreement.agreement_mandatory')]
        } else {
          return []
        }
        //Contexto OUTRAS CheckBoxes
        //If the clapp service getprofiledefinitions indicates it is mandatory to accept this field
        // an error is thrown when the field is not selected
      } else if (mandatory && mandatory === 1) {
        return [v => !!v || this.$vuetify.t('$vuetify.gdpr_agreement.agreement_mandatory')]
      } else {
        return []
      }
    },
    //@modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
    /**
     *
     * @param payload: {
     * 	"countryCode": "FR",
     *  "isValid": true,
     *  "phoneNumber": "0665656565",
     *  "countryCallingCode": "33",
     *  "formattedNumber": "+33665656565",
     *  "nationalNumber": "665656565",
     *  "formatInternational": "+33 6 65 65 65 65",
     *  "formatNational": "06 65 65 65 65",
     *  "uri": "tel:+33665656565",
     *  "e164": "+33665656565"
     *  }
     */
    define_selected_country_code(payload) {
      this.selected_country_code = payload.countryCallingCode
    },
    validateTaxNumberPT: function (nif) {
      if (nif && nif.length === 9) {
        let added = ((nif[7] * 2) + (nif[6] * 3) + (nif[5] * 4) + (nif[4] * 5) + (nif[3] * 6) + (nif[2] * 7) + (nif[1] * 8) + (nif[0] * 9));
        let mod = added % 11;
        let control;

        if (mod === 0 || mod === 1) {
          control = 0;
        } else {
          control = 11 - mod;
        }
        return parseInt(nif[8]) === control;
      } else {
        return false;
      }
    },
  },
  computed: {
    //The following rules use Arrow functions: in ES6 we have arrow functions with a more flexible syntax that
    //  has some bonus features and gotchas. One of the major advantages of arrow functions is that it does not
    //  have it's own 'this' value. It's 'this' is lexically bound to the enclosing scope.

    /**
     * Validations applied to the field NAME:
     * - mandatory
     * - can't have more than 20 characters
     * - exactly two names
     * @returns {Array} an array of validations
     */
    nameRules: function () {

      return [
        v => !!v || this.$vuetify.t('$vuetify.profile.name_required'),
        v => (v && v.length <= 20) || this.$vuetify.t('$vuetify.profile.name_invalid'),
        v => (v && v.trim().split(" ").length >= 2) || this.$vuetify.t('$vuetify.profile.name_invalid_two_names'),
      ]
    },
    minBirthDate() {
      // 100 year
      let date = new Date();
      date.setFullYear(date.getFullYear() - 100);

      return date.toISOString().substr(0, 10)
    },
    /**
     * Validations applied to the field BIRTH DATE:
     * - mandatory
     * - the calculated age has to be greater than 13
     * @returns {Array} an array of validations
     * */
    birthDateRules: function () {
      return [
        v => !!v || this.$vuetify.t('$vuetify.profile.birth_date_required'),
        v => this.checkMinors(v) || this.$vuetify.t('$vuetify.profile.birth_date_minors'),
      ]
    },
    /**
     * The field EMAIL is mandatory depending on the definition which is given by the getprofiledefinitions call.
     * When the field EMAIL is filled in, its content is checked to validate its format.
     * @returns {Array} an array of validations
     */
    emailRules() {
      var errors = [];
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //source: https://vuejs.org/v2/cookbook/form-validation.html#Using-Custom-Validation

      if (this.email_definition.mandatory === 1) {
        errors.push(v => !!v || this.$vuetify.t('$vuetify.profile.email_required'));
      }

      //If the email is not mandatory and it is not filled in, the 1st expression returns False and it is necessary to verify the 2nd condition
      //  the 2nd condition validates the email format, when the email is filled in
      errors.push(v => (this.email_definition.mandatory === 0 && !v || v && v.trim().length > 0 && re.test(v.trim())) || this.$vuetify.t('$vuetify.profile.email_invalid'));

      // If the Email is chosen as a Communication Mean or Electronic Invoice is chosen
      //  it is mandatory to fill in the Email's field
      if ((this.customer.send_1 || this.customer.send_7) && !this.customer.email_address) {
        errors.push(this.$vuetify.t('$vuetify.profile.email_required'));
      }

      return errors;
    },
    phoneRules: function () {
      var errors = [];
      let re = /^\d+$/;

      errors.push(v => !!v || this.$vuetify.t('$vuetify.profile.phone_number_required'));
      //modified @daniel.silva 2020.10.30 In other countries the phone does not have 9 digits
      //errors.push(v => (v && v.length === 9) || this.$vuetify.t('$vuetify.profile.phone_nine_digits'));
      errors.push(v => (v && re.test(v.trim())) || this.$vuetify.t('$vuetify.profile.phone_nine_digits'));

      return errors;
    },
    taxNumberRules: function () {
      let errors = [];
      //TODO pensar como validar outros paises!
      errors.push(v => !v || (v && v.length === 9) || this.$vuetify.t('$vuetify.profile.tax_number_nine_digits'));
      errors.push(v => !v || this.validateTaxNumberPT(v) || this.$vuetify.t('$vuetify.profile.tax_number_invalid'));

      return errors;
    },
    /**
     * The field GENDER is mandatory depending on the definition which is given by the getprofiledefinitions call
     * @type {Array}
     */
    genderRules() {
      var errors = [];
      if (this.gender_definition.mandatory === 1) {
        errors.push(v => !!v || this.$vuetify.t('$vuetify.profile.gender_required'));
      }

      return errors;
    },
    /**
     * If the profile has an option to accept personalized communication and this option is selected,
     * one of the communication means has to be checked
     * @returns {[]}
     */
    agreementRulesGeneric() {
      var errors = [];
      //@modified ana.castro 2019.10.28 Bug Fix
      // if (this.checkboxs_contact_type.personalized && this.customer.send_6 &&
      //     ((!this.customer.send_1 && !this.customer.send_2 && !this.customer.send_3 && !this.customer.send_4 && !this.customer.send_5)
      //         || (this.newUser && !this.customer.send_communication_generally))) {
      //     errors.push(this.$t('agreement_communication_means_mandatory'))
      // }

      var valid = false;
      if (this.checkboxs_contact_type.personalized && this.customer.send_6) {
        if (!this.newUser) {
          if (this.checkboxs_contact_type && this.checkboxs_contact_type.email && this.customer.send_1) {
            valid = true
          } else if (this.checkboxs_contact_type && this.checkboxs_contact_type.sms && this.customer.send_2) {
            valid = true
          } else if (this.checkboxs_contact_type && this.checkboxs_contact_type.phone && this.customer.send_3) {
            valid = true
          } else if (this.checkboxs_contact_type && this.checkboxs_contact_type.notification && this.customer.send_4) {
            valid = true
          } else if (this.checkboxs_contact_type && this.checkboxs_contact_type.onlinead && this.customer.send_5) {
            valid = true
          }
        } else if (this.newUser) {
          if (this.customer.send_communication_generally) {
            valid = true
          }
        }

        if (!valid) {
          errors.push(this.$vuetify.t('$vuetify.gdpr_agreement.agreement_communication_means_mandatory'))
        }
      }

      return errors;
    },

    //@modified ana.castro 2019.11.26 SCLAPP-23: Customer's favourite store-->
    favouriteStoreOptions() {
      let stores_list = this.stores;
      if (stores_list) {
        for (var i = 0; i < stores_list.length; i++) {
          if (stores_list[i].latitude && stores_list[i].longitude) {
            stores_list[i].distance = getDistanceFromLatLonInKm(stores_list[i].latitude, stores_list[i].longitude, this.location.latitude, this.location.longitude)
          } else {
            stores_list[i].distance = undefined;
          }
        }

        stores_list.sort(function (a, b) {
          if (a.distance === undefined && b.distance === undefined)
            return 0;
          else if (a.distance === undefined)
            return 1;
          else if (b.distance === undefined)
            return -1;
          return a.distance - b.distance;
        });
      }

      var returnOptions = [];

      returnOptions.push('');

      if (stores_list) {
        for (var j = 0; j < stores_list.length; j++) {
          returnOptions.push({text: stores_list[j].name, value: stores_list[j].id})
        }
      }

      return returnOptions
    },
    //@modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
    ...mapGetters({
      countryCode: 'configs/countryCode',
      preferredCountryCodes: 'configs/preferredCountryCodes',
        baseUrl: 'configs/apiImgBaseUrl',
    }),
  },
  mounted() {
    this.dark_theme = process.env.VUE_APP_VUETIFY_DARK_THEME === "True";
    // eslint-disable-next-line
    apiFetch('getprofiledefinitions/').then(result => {
          this.checkbox_text_tc_accept = result.text_tc_accept;
          this.checkbox_text_communications_accept = result.text_communications_accept;
          this.checkbox_text_personal_campaigns = result.text_personal_campaigns;
          this.checkbox_text_einvoice = result.text_einvoice;
          this.checkboxs_contact_type = result.contact_type;
          this.dialog_text = result.text_tc_accept_complete;
          this.email_definition = result.profile_fields.mail;
          this.tax_number_definition = result.profile_fields.tax_number;
          this.gender_definition = result.profile_fields.gender;
          //Using a Parent's computed prop to update a Parent's flag
          this.setLoadedDefinitions("profile_definitions", true);
        },
        // eslint-disable-next-line
        error => {
          this.$log.warn("error");
        });

    this.loyalty_program_name = this.$store.state.configs.loyaltyProgramName;

    storesService.getAllResume().then(result => {
          this.stores = result.results;
          this.$store.dispatch("loader/setLoading", false);
        },
    );

    //https://developer.mozilla.org/pt-BR/docs/Web/API/Position
    //Getting user's current geo location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.location = position.coords;
      })
    }
    //TODO No caso de o cliente não ter aceite os T&C o panel deve ser 0!
    if (this.newUser) {
      this.panel = 0;
      this.attr_readonly = 'readonly';
      this.attr_hide_actions = true;
    } else {
      this.panel = [];
      this.attr_readonly = false;
      this.attr_hide_actions = false;
    }

    //@modified ana.castro 2019.09.13 save_button_profile disabled sometimes
    // this.$store.subscribe((mutation, state) => {
    //     switch (mutation.type) {
    //         case 'configs/setGeneralConfig':
    //             this.loyalty_program_name = state.configs.loyaltyProgramName;
    //             //Using a Parent's computed prop to update a Parent's flag
    //             this.setLoadedDefinitions("generic_definitions", true);
    //             break;
    //     }
    // })
    this.locale = process.env.VUE_APP_LANG;
  }
}
</script>

<style scoped>

</style>